import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
  Col,
  Container,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Card,
  CardBody,
  Button,
  Label,
  Form, FormGroup, Input, InputGroup,
} from "reactstrap"

import { withRouter } from "react-router-dom"
import { map } from "lodash"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import Cards
import CardReport from "./report-card"

import { getAllReports, getAllReportsForGroupAdmin, getBranches, getGroupUsers } from "store/group/reports/actions"
import { API_URL } from "helpers/api_helper"
import { replaceAll } from 'components/Common/Util'
import { getUserRole } from "components/Common/Roles"
import { isEmpty, isEqual } from "lodash"
import EmptyPage from "pages/Common/EmptyPage";
import Select from "react-select"
import makeAnimated from "react-select/animated"
import { toggleRightSidebar } from "store/actions";
import { GET_BRANCHES } from "store/group/reports/actionTypes";
import { RESULT_OK } from "store/baseActionTypes";

class ReportsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      totalPage: 10, //replace this with total pages of data
      pageSize: 10,
      sortOrder: 'desc',
      search: '',
      name: '',
      refferedBy: '',
      mobile: '',
      city: '',
      branchName: '',
      groupUserName: '',
      branchId: '',
      groupUserId: '',
      reportCreatedDate: new Date(),
      itemsCountPerPage: null,
      totalItemsCount: null,
      actionResult: {},
      actionResultChanged: false,
      userBirthChartList: [],
      loading: false,
      clearButton: false,
      selectedBranch: [],
      selectedUser: [],
      optionBranch: [],
      optionUsers: []

    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.handleDownload = this.handleDownload.bind(this)
  }

  componentDidMount() {
    console.log("componentDidMount->called")
    let userRoles = getUserRole()
    if (userRoles.isGRPGroupUser) {
      const { onGetAllReportForGroupUser } = this.props
      onGetAllReportForGroupUser(0, this.state.pageSize,
        this.state.sortOrder, this.state.reportCreatedDate,
        this.state.name, this.state.refferedBy, this.state.city, this.state.mobile)
    } else if (userRoles.isGRPGroupAdmin) {
      const { onGetAllReportForGroupAdmin, onGetBranches } = this.props
      onGetAllReportForGroupAdmin(0, this.state.pageSize,
        this.state.sortOrder, this.state.reportCreatedDate, this.state.name, this.state.refferedBy, this.state.city,
        this.state.mobile, this.state.selectedBranch.value, this.state.selectedUser.value)
      onGetBranches()
    } else if (userRoles.isGRPBranchAdmin) {
      return;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { userBirthChartListPage, actionResult, branches, groupUsers } = this.props
    if (!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult)) {
      console.log("componentDidUpdate->actionResult changed")
      this.setState({ actionResult, actionResultChanged: true })
      console.log("actionResult: ", actionResult)
    }

    if (!isEmpty(userBirthChartListPage)) {
      if (!isEqual(prevProps.userBirthChartListPage.userBirthChartList, userBirthChartListPage.userBirthChartList)
        || userBirthChartListPage.size !== this.state.itemsCountPerPage) {
        console.log("componentDidUpdate->birthChartListPageChanged");
        this.setState({
          userBirthChartList: userBirthChartListPage.userBirthChartList,
          totalItemsCount: userBirthChartListPage.totalElements,
          itemsCountPerPage: userBirthChartListPage.size,
          totalPage: userBirthChartListPage.totalPages > 10 ? 10 : userBirthChartListPage.totalPages,
        })
      }
    }

    if (!isEmpty(branches) && !isEqual(prevProps.branches, branches)) {
      this.setState({ optionBranch: branches })
      console.log("setState->called->branches")
    }

    if (!isEmpty(groupUsers) && !isEqual(prevProps.groupUsers, groupUsers)) {
      this.setState({ optionUsers: groupUsers })
      console.log("setState->called->groupUsers")
    }
  }

  handleValidSubmit(event, values) {
    event.preventDefault()
    console.log("inside valid submit :::::")
    console.log("form submit values", values)
    console.log("userObj: ", this.state.selectedUser)
    console.log("userId: ", this.state.selectedUser.value)
    let createdDate = new Date(this.state.reportCreatedDate).toDateString();
    let userRoles = getUserRole()
    console.log("handleValidSubmit")
    console.log("userRoles ", userRoles)
    if (this.state.filterButton) {
      this.setState({
        page: 1,
        totalPage: 0,
        pageSize: 10,
      })
      if (userRoles.isGRPGroupUser) {
        const { onGetAllReportForGroupUser } = this.props
        onGetAllReportForGroupUser(this.state.page - 1, this.state.pageSize, this.state.sortOrder,
          createdDate, this.state.name, this.state.refferedBy, this.state.city, this.state.mobile)
      } else if (userRoles.isGRPGroupAdmin) {
        const { onGetAllReportForGroupAdmin } = this.props
        onGetAllReportForGroupAdmin(this.state.page - 1, this.state.pageSize,
          this.state.sortOrder, createdDate, this.state.name, this.state.refferedBy, this.state.city,
          this.state.mobile, this.state.selectedBranch.value, this.state.selectedUser.value)
      }
    } else if (this.state.clearButton) {
      console.log("inside clear button")
      this.setState({
        name: '',
        userName: '',
        refferedBy: '',
        mobile: '',
        city: '',
        selectedUser: '',
        optionUsers: [],
        selectedBranch: '',
        optionBranch: []
      })
      if (userRoles.isGRPGroupUser) {
        const { onGetAllReportForGroupUser } = this.props
        onGetAllReportForGroupUser(0, this.state.pageSize,
          this.state.sortOrder, createdDate,
          this.state.name, this.state.refferedBy, this.state.city, this.state.mobile)
      } else if (userRoles.isGRPGroupAdmin) {
        const { onGetAllReportForGroupAdmin } = this.props
        onGetAllReportForGroupAdmin(0, this.state.pageSize,
          this.state.sortOrder, createdDate, this.state.name, this.state.refferedBy, this.state.city,
          this.state.mobile, this.state.selectedBranch.value, this.state.selectedUser.value)
      } else if (userRoles.isGRPBranchAdmin) {
        return;
      }
    }
  }

  handlePageClick = page => {
    this.setState({ page })

    console.log("handlePageClick->called")
    let userRoles = getUserRole()
    if (userRoles.isGRPGroupUser) {
      const { onGetAllReportForGroupUser } = this.props
      onGetAllReportForGroupUser(page - 1, this.state.pageSize, this.state.sortOrder,
        this.state.reportCreatedDate, this.state.name, this.state.refferedBy, this.state.city, this.state.mobile)
    } else if (userRoles.isGRPGroupAdmin) {
      const { onGetAllReportForGroupAdmin, onGetBranches } = this.props
      onGetAllReportForGroupAdmin(page - 1, this.state.pageSize,
        this.state.sortOrder, this.state.reportCreatedDate, this.state.name, this.state.refferedBy, this.state.city,
        this.state.mobile, this.state.selectedBranch.value, this.state.selectedUser.value)
      //onGetBranches()
    } else if (userRoles.isGRPBranchAdmin) {
      return;
    }
  }

  handleDownload(birthChartId, birthChartName) {
    console.log("inside props handle Download :::: project grid common place")
    try {
      let userRoles = getUserRole()
      let birthReportUrl;
      if (userRoles.isGRPGroupAdmin) {
        birthReportUrl = "group/group-admin/report/PDF"
      } else if (userRoles.isGRPGroupUser) {
        birthReportUrl = "group/report/PDF"
      } else {
        birthReportUrl = "group/report/PDF"
      }
      const obj = JSON.parse(sessionStorage.getItem("authUser"))
      const config = {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'Authorization': 'Bearer ' + obj.token
        },
      }
      fetch(`${API_URL}/${birthReportUrl}?id=${birthChartId}`, config)
        .then(response => {
          if (response.status != 200) {
            return
          }
          const filename = "AIReport_" + replaceAll(birthChartName);
          response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
          });
        });
    } catch (error) {
      console.log(error)
    }
  }

  handleBranchChange = selectedBranch => {
    console.log("branch->changed")
    console.log("branch id: ", selectedBranch.value)
    let userRoles = getUserRole()
    let userType;
    if (userRoles.isGRPGroupAdmin) {
      userType = "GROUP_ADMIN"
    } else if (userRoles.isGRPBranchAdmin) {
      userType = "BRANCH_ADMIN"
    } else {
      userType = "GROUP_ADMIN"
    }
    this.setState({ selectedUser: '' })
    this.setState({ optionUsers: [] })
    this.setState({ selectedBranch })
    const { onGetGroupUsers } = this.props
    onGetGroupUsers(selectedBranch.value, userType)
  }

  handleUserChange = selectedUser => {
    console.log("user->changed")
    console.log("user id: ", selectedUser.value)
    this.setState({ selectedUser })
  }

  render() {
    const { page, totalPage, userBirthChartList, actionResult, loading } = this.state
    let userRoles = getUserRole()
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>View Birth Chart | Kattam - Birth Chart</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItem="View AI Reports" />

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleValidSubmit}>
                      {userRoles.isGRPGroupAdmin && (
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <Label>Branch</Label>
                              <Select
                                value={this.state.selectedBranch}
                                options={this.state.optionBranch}
                                onChange={this.handleBranchChange}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <Label>User</Label>
                              <Select
                                value={this.state.selectedUser}
                                options={this.state.optionUsers}
                                onChange={this.handleUserChange}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      )}

                      {userRoles.isGRPBranchAdmin && (
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <Label>User</Label>
                              <Select
                                value={this.state.selectedUser}
                                options={this.state.optionUsers}
                                onChange={this.handleUserChange}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      )}

                      <Row className="mt-3">
                        <Col sm="6" className="col-xl">
                          <FormGroup>
                            <Label>Name</Label>
                            <Input
                              name="userName"
                              id="userName"
                              className="form-control"
                              placeholder="Name"
                              type="text"
                              onChange={(e) => {
                                this.setState({ name: e.target.value })
                              }}
                              value={this.state.name}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6" className="col-xl">
                          <FormGroup>
                            <Label>Reffered by</Label>
                            <Input
                              name="refferedBy"
                              id="refferedBy"
                              className="form-control"
                              placeholder="Reffered by"
                              type="text"
                              onChange={(e) => {
                                this.setState({ refferedBy: e.target.value })
                              }}
                              value={this.state.refferedBy}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6" className="col-xl">
                          <FormGroup>
                            <Label>Mobile</Label>
                            <Input
                              name="mobile"
                              id="mobile"
                              className="form-control"
                              placeholder="Mobile"
                              type="text"
                              validate={{
                                pattern: { value: '^[0-9]{8,10}$', errorMessage: 'Please enter a valid mobile.' }
                              }}
                              onChange={(e) => {
                                this.setState({ mobile: e.target.value })
                              }}
                              value={this.state.mobile}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6" className="col-xl">
                          <FormGroup>
                            <Label>City</Label>
                            <Input
                              name="city"
                              id="city"
                              className="form-control"
                              placeholder="City"
                              type="text"
                              onChange={(e) => {
                                this.setState({ city: e.target.value })
                              }}
                              value={this.state.city}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6" className="col-xl align-self-end">
                          <div className="mt-3">
                            <Button
                              onClick={() => {
                                this.setState({
                                  filterButton: true,
                                  clearButton: false
                                })
                              }}
                              type="button"
                              color="primary"
                              type="submit"
                              className=""
                            >
                              <i className="mdi mdi-filter me-2" />
                              Filter
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                              onClick={() => {
                                this.setState({
                                  clearButton: true,
                                  filterButton: false
                                })
                              }}
                              type="button"
                              color="primary"
                              type="submit"
                              className=""
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <CardReport handleDownload={this.handleDownload} birthChartList={userBirthChartList} key={"birthChart"} />
            </Row>

            <Row>
              <Col lg="12">
                <Pagination className="pagination pagination-rounded justify-content-center mt-2 mb-5">
                  <PaginationItem disabled={page === 1}>
                    <PaginationLink
                      previous
                      href="#"
                      onClick={() => this.handlePageClick(page - 1)}
                    />
                  </PaginationItem>
                  {map(Array(totalPage), (item, i) => (
                    <PaginationItem active={i + 1 === page} key={'_k' + i}>
                      <PaginationLink
                        onClick={() => this.handlePageClick(i + 1)}
                        href="#"
                      >
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={page === totalPage}>
                    <PaginationLink
                      next
                      href="#"
                      onClick={() => this.handlePageClick(page + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ReportsPage.propTypes = {
  userBirthChartListPage: PropTypes.object,
  actionResult: PropTypes.object,
  birthChartList: PropTypes.array,
  branches: PropTypes.array,
  groupUsers: PropTypes.array
}

const mapStateToProps = ({ grpReports }) => ({
  userBirthChartListPage: grpReports.userBirthChartListPage,
  actionResult: grpReports.actionResult,
  branches: grpReports.branches,
  groupUsers: grpReports.groupUsers
})

const mapDispatchToProps = dispatch => ({
  onGetAllReportForGroupUser: (page, size, sortOrder, reportCreatedDate, name, refferedBy, city,
    mobile) => dispatch(getAllReports(page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile)),
  onGetBranches: () => dispatch(getBranches()),
  onGetGroupUsers: (id, userType) => dispatch(getGroupUsers(id, userType)),
  onGetAllReportForGroupAdmin: (page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile,
    branchId, groupUserId) => dispatch(getAllReportsForGroupAdmin(page, size, sortOrder, reportCreatedDate,
      name, refferedBy, city, mobile, branchId, groupUserId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReportsPage))
